import { FC, ReactNode, useState, useMemo, useContext, createContext, Dispatch, SetStateAction } from 'react'
import { Petition } from 'backoffice/components/DropRequests/usePetitionsQuery'
import { Actions } from 'backoffice/components/DropRequests/types/types'

interface ActionModal {
  petition: Petition
  action: Actions
}

export const ActionModalContext = createContext<{
  actionModal: ActionModal | null
  setActionModal: Dispatch<SetStateAction<ActionModal | null>>
}>({
  actionModal: null,
  setActionModal: () => {},
})

export const useActionModalContext = () => useContext(ActionModalContext)

export const ActionModalContextProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const [actionModal, setActionModal] = useState<ActionModal | null>(null)

  const providerData = useMemo(() => ({ actionModal, setActionModal }), [actionModal])

  return <ActionModalContext.Provider value={providerData}>{children}</ActionModalContext.Provider>
}
